export default function UpdateCheckIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4062 5.90625L4.21875 12.0938L1.125 9.00014M16.875 5.90625L10.6875 12.0938L9.04409 10.4504"
        stroke="#E82C4C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
